/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import FavoritesTable from './FavoritesTable';

export default function FavoritesList() {

  return (
    <Box mb={2}>
      <Box mb={2}>
        <Typography>Mis productos favoritos</Typography>
      </Box>
      <FavoritesTable />
    </Box>
  );
}
